let routes = [
  {
    path: '/demande-inscription-psychotherapeute',
    component: () => import('../views/DemandeInscriptionPsychotherapeute.vue'),
    props: true
  },
  {
    path: '/demande-inscription-psychotherapeute/:step',
    component: () => import('../views/DemandeInscriptionPsychotherapeute.vue'),
    props: true
  }
]

export default routes;